import * as React from 'react'

import * as styles from './imagePlaceholder.module.css'

interface IProps {
  width?: number | string
  height?: number | string
  className?: string
  children?: any
}

const ImagePlaceholder = ({
  width = '100%',
  height = '100%',
  className = '',
  children
}: IProps) => (
  <div className={`${styles.root} ${className}`} style={{ width, height }}>
    {children}
  </div>
)

export default ImagePlaceholder
